export default "__VITE_ASSET__DaFhRqan__"